export default __webpack_public_path__ + "static/media/nodejs.ad2a9a88.svg";